import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {getClientWalletList} from '../../services/ClientWalletService'

interface GetClientWalletListParams {
  pageNumber: number
  pageSize: number
  filterkey: any
}

interface ClientWalletState {
  ClientWalletList: any
}

const initialState: ClientWalletState = {
  ClientWalletList: null,
}

// Fetch clientWallet list
export const getClientWalletListApi = createAsyncThunk(
  'clientWallet/getClientWalletList',
  async ({pageNumber, pageSize, filterkey}: GetClientWalletListParams, {rejectWithValue}) => {
    try {
      const result = await getClientWalletList(pageNumber, pageSize, filterkey)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

const ClientWalletSlice = createSlice({
  name: 'clientWallet',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getClientWalletListApi.fulfilled, (state, action) => {
      state.ClientWalletList = action.payload
    })
  },
})

export default ClientWalletSlice
